import { Component } from "react";
import { IoRefreshOutline, IoWarningOutline, IoHomeOutline } from "react-icons/io5";

/**
 * Global error boundary. Prevents white screens when a page component throws.
 * Shows a friendly recovery UI with retry and "go home" actions.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  handleHome = () => {
    this.setState({ hasError: false, error: null });
    try { window.location.href = "/"; } catch { /* noop */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="mobile-frame" data-testid="error-boundary" style={{ padding: 24 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 18,
            paddingTop: 40,
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 84,
              height: 84,
              borderRadius: 999,
              background: "var(--tf-red-soft)",
              color: "var(--tf-red)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IoWarningOutline size={44} />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Qualcosa è andato storto</h2>
          <p style={{ color: "var(--tf-muted)", margin: 0, maxWidth: 320, lineHeight: 1.4 }}>
            L&apos;app ha incontrato un problema. Riprova, oppure torna alla home.
            Se il problema persiste, fai screenshot e segnalalo.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%", maxWidth: 320 }}>
            <button
              type="button"
              data-testid="error-retry"
              className="tf-btn-primary"
              onClick={this.handleRetry}
            >
              <IoRefreshOutline size={20} /> Riprova
            </button>
            <button
              type="button"
              data-testid="error-home"
              className="tf-btn-ghost"
              onClick={this.handleHome}
            >
              <IoHomeOutline size={20} /> Torna alla Home
            </button>
          </div>
          {this.state.error && (
            <details style={{ marginTop: 12, fontSize: 12, opacity: 0.6, maxWidth: 360 }}>
              <summary>Dettagli tecnici</summary>
              <pre style={{ textAlign: "left", overflow: "auto", padding: 8 }}>
                {String(this.state.error?.message || this.state.error)}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
